<template>
  <Header />
  <article>
    <div class="kv">
      <div class="caption">
        <h1>企業文化與福利</h1>
      </div>
    </div>
    <section class="sect1">
      <div class="ctx">
        <p>和平電廠作為台泥企業團子公司，秉持集團企業理念與多元 Diversity、平等 Equity、共融 Inclusion 精神，以員工需求為優先，透過「性別平權、世代共融、種族包容」三大主軸正視企業人才結構議題，推動以人為本企業文化，營造公正且充滿活力的友善職場。</p>
        <p>我們重視跨代共融，員工的多元性、尊重及接納個體差異，並積極促進不同世代的溝通協作，建立和諧健康的工作環境。</p>
        <a target="_blank" href="https://www.104.com.tw/company/7e7nehs?jobsource=google">→ 了解和電最新工作機會</a>
        <div class="gallery">
          <div class="imgContainer imgContainer1-1">
            <div class="tit">
              <div class="icon"><img src="@/assets/joinBenefit/icon1_01.png" /></div>
              <div class="name">和電龍舟隊</div>
            </div>
          </div>
          <div class="imgContainer imgContainer1-2">
            <div class="tit">
              <div class="icon"><img src="@/assets/joinBenefit/icon1_02.png" /></div>
              <div class="name">社團活動</div>
            </div>
          </div>
          <div class="imgContainer imgContainer1-3">
            <div class="tit">
              <div class="icon"><img src="@/assets/joinBenefit/icon1_03.png" /></div>
              <div class="name">單車環島挑戰</div>
            </div>
          </div>
          <div class="imgContainer imgContainer1-4">
            <div class="tit">
              <div class="icon"><img src="@/assets/joinBenefit/icon1_04.png" /></div>
              <div class="name">歌唱大賽</div>
            </div>
          </div>
        </div>
        <div class="sectTit">員工持股信託</div>
        <p>同仁由每月薪資中提撥固定金額，同時公司也相對提撥 1:1 公提金共同存至專用信託專戶，並提供已參與之同仁每年 6 月、12 月申請單筆持股信託增額同享方案，同時陪存自提金之 10% 至個人信託帳戶。此外，屆齡 60 歲退休的台泥夥伴更可加乘提撥，不僅達到留才目的，更協助同仁累積財富，規劃未來退休生活。2023 年參與率 95.43%。</p>
      </div>
    </section>
    <section class="sect2">
      <div class="ctx">
        <div class="sectTit">有薪志工假</div>
        <div class="volunteer">
          <div class="left">
            <img src="@/assets/joinBenefit/pic2_01.png" />
            <div class="info" ref="info">
              <div class="block1"><span class="year">2024</span> 年<br>申請人次</div>
              <div class="block2"> <span class="num1">47</span> 人/共 <span class="num2">200</span> 小時</div>
            </div>
          </div>
          <div class="right">
            2018 年 9 月，台泥企業團正式推出「有薪志工假」，鼓勵同仁工作之餘踴躍投入公益服務、回饋社會。台泥也與外部慈善協會合作，不定期於各營運據點所在縣市舉辦多元志工活動，並開設志工基礎訓練課程，依照衛生福利部指引，協助同仁了解志願服務內涵與倫理、服務經驗分享及相關法規，透過關懷長者與弱勢族群、共同製作春節禮盒或水泥手作、協助居家修繕等，攜手同仁開創職場以外對社會的多元投入。
          </div>
        </div>
        <br>
        <div class="gallery">
          <div class="left">
            <div class="imgContainer2-1"></div>
          </div>
          <div class="right">            
            <div class="imgContainer2-2"></div>
          </div>
        </div>
      </div>
    </section>
    <section class="sect3">
      <div class="ctx">
        <div class="sectTit">和平電力員工福利</div>
        <div class="benefit">
          <div class="left">
            <template v-for="(row, idx) in benefit" :key="idx">
              <div class="item" v-if="idx<6">
                <div class="icon">
                  <img :src=getBenefitIcon(row.icon) />
                  <div class="tit">{{row.tit}}</div>
                </div>
                <div class="bList">
                  <template v-for="(row2, idx) in row.bList" :key="idx">
                    <div>{{row2.txt}}</div>
                    <div class="note">{{row2.note}}</div>
                  </template>
                </div>
              </div>
            </template>
          </div>
          <div class="right">
            <template v-for="(row, idx) in benefit" :key="idx">
              <div class="item" v-if="idx==6">
                <div class="icon">
                  <img :src=getBenefitIcon(row.icon) />
                  <div class="tit">{{row.tit}}</div>
                </div>
                <div class="bList">
                  <template v-for="(row2, idx) in row.bList" :key="idx">
                    <div>{{row2.txt}}</div>
                    <div class="note">{{row2.note}}</div>
                  </template>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </section>
  </article>
  <Footer />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Util, ImgContainerAutoResize, NumRun } from '../../util/util';
import Header from '../../components/Header.vue';
import Footer from '../../components/Footer.vue';

export default defineComponent({
  name: 'JoinBenefit',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      infoBoundingBottom: 0,
      infoHeight: 0,
      isShowNum: false,
      benefit: [
        {
          icon: "icon3_01.png",
          tit: "獎金 / 禮品類",
          bList: [
            {txt: "二個月年終獎金", note:""}, 
            {txt: "績效獎金", note: "(視營運狀況提撥)"}, 
            {txt: "季獎金", note: "(視營運狀況提撥)"}, 
            {txt: "四節禮金", note: ""}, 
            {txt: "生日禮金", note: ""}, 
            {txt: "員工持股信託", note: ""}
          ]
        },
        {
          icon: "icon3_02.png",
          tit: "保險類",
          bList: [
            {txt: "勞保", note: ""}, 
            {txt: "健保", note: ""}, 
            {txt: "員工團保", note: "(壽險/癌症險/住院醫療/意外險/職災險)"}, 
            {txt: "眷屬團保", note: ""}
          ]
        },
        {
          icon: "icon3_03.png",
          tit: "設備類",
          bList: [
            {txt: "外地員工宿舍", note: ""}, 
            {txt: "提供個人舒適套房", note: "(宜花除外)"}, 
            {txt: "員工餐廳及合作社", note: ""}, 
            {txt: "員工交通車廠區接駁", note: ""}, 
            {txt: "健身房", note: ""}, 
            {txt: "羽球館", note: ""}, 
            {txt: "員工多元休息空間", note: "(醫護室、哺乳室、諮商室)"}
          ]
        },
        {
          icon: "icon3_05.png",
          tit: "輔助類",
          bList: [
            {txt: "結婚禮金", note: ""}, 
            {txt: "生育津貼", note: ""}, 
            {txt: "子女教育獎助學金", note: ""}, 
            {txt: "旅遊補助", note: ""}, 
            {txt: "住院慰問金", note: ""}, 
            {txt: "社團費用補助", note: ""}, 
            {txt: "醫療補助", note: "(直系親屬含父母、子女、配偶皆可申請補助)"}, 
            {txt: "喪葬慰問金", note: ""}, 
            {txt: "宜花同仁通勤費補助", note: ""}, 
            {txt: "電動機車購車補助", note: ""}
          ]
        },
        {
          icon: "icon3_06.png",
          tit: "休閒類",
          bList: [
            {txt: "社團活動", note: ""}, 
            {txt: "自強活動", note: ""}, 
            {txt: "球類比賽", note: ""}
          ]
        },
        {
          icon: "icon3_07.png",
          tit: "其他",
          bList: [
            {txt: "新進同仁健康檢查全額補助", note: "(指定配合醫院)"}, 
            {txt: "每年員工健檢補助", note: ""}, 
            {txt: "每二年免費員工健康檢查", note: ""}, 
            {txt: "每年流感疫苗免費注射", note: ""}
          ]
        },
        {
          icon: "icon3_04.png",
          tit: "請 / 休假制度",
          bList: [
            {txt: "週休二日", note: "(輪班人員依輪班表出勤)"}, 
            {txt: "陪產假", note: ""}, 
            {txt: "生理假", note: ""}, 
            {txt: "家庭照顧假", note: ""}, 
            {txt: "安薪照顧假", note: ""}, 
            {txt: "優於勞基法之特休假制度", note: ""}, 
            {txt: "給薪事病假", note: ""}, 
            {txt: "志工服務假", note: ""}, 
            {txt: "疫苗接種假", note: ""}, 
            {txt: "歲時祭儀假", note: ""}
          ]
        }
      ]
    }
  },
  methods:{
    showNum: function() {
      new NumRun(document.querySelector(".num1") as HTMLElement, 500);
      new NumRun(document.querySelector(".num2") as HTMLElement, 500);
    },
    chkShowNum: function() {
      let _this = this;
      this.infoBoundingBottom = (this.$refs.info as HTMLElement).getBoundingClientRect().bottom;
      this.infoHeight = (this.$refs.info as HTMLElement).offsetHeight;

      if( Util.getDomHeight() > (_this.infoBoundingBottom + 50)) {
        if(!_this.isShowNum) {          
          _this.isShowNum = true;
          _this.showNum();
        }
      }

      // if( window.scrollY + Util.getDomHeight() > _this.coralOffsetTop ) {
      // }

      // if( window.scrollY + Util.getDomHeight() > _this.coralOffsetTop + _this.coralHeight) {
      // }
    },
    getBenefitIcon: function(file: string) {
      return require(`@/assets/joinBenefit/${file}`);
    }
  },
  mounted() {
    setTimeout( () => {
      this.chkShowNum();
    }, 100);

    window.addEventListener("scroll", () => {
      this.chkShowNum();
    });

    new ImgContainerAutoResize(document.querySelector(".kv") as HTMLElement, 0.368);
    new ImgContainerAutoResize(document.querySelector(".imgContainer1-1") as HTMLElement, 0.65);
    new ImgContainerAutoResize(document.querySelector(".imgContainer1-2") as HTMLElement, 0.65);
    new ImgContainerAutoResize(document.querySelector(".imgContainer1-3") as HTMLElement, 0.65);
    new ImgContainerAutoResize(document.querySelector(".imgContainer1-4") as HTMLElement, 0.65);
    new ImgContainerAutoResize(document.querySelector(".imgContainer2-1") as HTMLElement, 0.55);
    new ImgContainerAutoResize(document.querySelector(".imgContainer2-2") as HTMLElement, 0.85);
  }
});
</script>

<style>
.kv {
  height: 700px;
  position: relative;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.5) 0, rgba(0, 0, 0, 0) 20%), url("@/assets/joinBenefit/kv.webp");
  background-position: center, center bottom;
  background-size: cover, cover;
}

.kv .caption {
  width: 1200px;
  margin: 0 auto;
  padding: 25px 0;
  box-sizing: border-box;
}

.kv .caption h1 {
  margin: 0;
  display: inline-block;
  letter-spacing: 5px;
  font-weight: bold;
  font-size: 52px;
  color: #fff;
  text-shadow: 5px 5px 5px #00000066;
}

.sect1 {
  background: radial-gradient(circle at 50% 100%, #f0f0f0 0, #f0f0f0 50%, #ffffff00 50.1%);
}
 
.sect1 p {
  line-height: 2em;
}

.sect1 a {
  margin: 0 0 60px;
  padding: 5px 20px 7px;
  display: inline-block;
  border: solid 1px #808080;
  border-radius: 30px;
  font-size: 20px;
  color: #fff;
  background: #0C5F99;
  transform-origin: left center;
  /* transition: border 0.5s, transform 0.5s; */
  animation: btnBreath 1.2s ease-in-out 0s infinite alternate forwards;
}

@keyframes btnBreath {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.1);
  }
}

.sect1 a:hover {
  border: solid 1px #0C5F99;
  transform: scale(1.1);
}

.sect1 .gallery {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  overflow: hidden;
  border-radius: 30px;
}

.sect1 .gallery .imgContainer {
  position: relative;
}

.sect1 .gallery .imgContainer .tit {
  display: inline-flex;
  align-items: center;
}

.sect1 .gallery .imgContainer .tit .icon {
  flex: 0 0 100px;
  box-sizing: border-box;
  overflow: visible;
}

.sect1 .gallery .imgContainer .tit .icon img {
  width: 100%;
  position: relative;
}

.imgContainer .tit .name {
  flex: 0 0 auto;
  margin: 0 0 0 -25px;
  padding: 5px 25px;
  box-sizing: border-box;
  font-weight: bold;
  font-size: 20px;
  color: #fff;
  background: linear-gradient(to right, #00000088 0, #00000010 100%);
}

.sect1 .gallery .imgContainer1-1 {
  width: 49.8%;
  margin: 0 0 5px;
  background: url(@/assets/joinBenefit/pic1_01.jpg) center;
  background-size: cover;
}

.sect1 .gallery .imgContainer1-2 {
  width: 49.8%;
  background: url(@/assets/joinBenefit/pic1_02.jpg) center;
  background-size: cover;
}

.sect1 .gallery .imgContainer1-3 {
  width: 49.8%;
  margin: 0 0 5px;
  background: url(@/assets/joinBenefit/pic1_03.jpg) left center;
  background-size: cover;
}

.sect1 .gallery .imgContainer1-4 {
  width: 49.8%;
  background: url(@/assets/joinBenefit/pic1_04.jpg) center;
  background-size: cover;
}

.sect1 .sectTit {
  margin: 40px 0 0;
  padding: 5px 0;
  box-sizing: border-box;
  display: inline-block;
  border-top: solid 1px #0C5F99;
  border-bottom: solid 1px #0C5F99;
  letter-spacing: 2px;
  font-size: 24px;
  color: #0C5F99;
}

.sect2 {
  background: url(@/assets/joinBenefit/sectBack2.png) center;
  background-size: cover;
}

.sect2 .sectTit {
  width: 300px;
  margin: auto;
  padding: 10px 20px;
  box-sizing: border-box;
  position: absolute;
  top: -35px;
  left: 0;
  right: 0;
  border-radius: 50px;
  letter-spacing: 2px;
  text-align: center;
  font-size: 36px;
  /* color: #63BFAA; */
  color: #E99776;
  background: #F4F3F3;
}

.sect2 .volunteer {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.sect2 .volunteer .left {
  flex: 0 0 45%;
}

.sect2 .volunteer .left img {
  width: 100%;
}

.sect2 .volunteer .left .info {
  margin: 20px 0;
  padding: 0px 20px 3px;
  box-sizing: border-box;
  border: solid 3px #63BFAA;
  border-radius: 50px;
  background: #fff;
}

.sect2 .volunteer .left .info .block1 {
  width: 25%;
  display: inline-block;
  border-right: solid 3px #63BFAA;  
  line-height: 1.3em;
  text-align: center;
}

.sect2 .volunteer .left .info .block1 .year {
  font-weight: bold;
  font-size: 24px;
}

.sect2 .volunteer .left .info .block2 {
  width: 70%;
  display: inline-block;
  text-align: center;
}

.sect2 .volunteer .left .info .block2 .num1,
.sect2 .volunteer .left .info .block2 .num2 {
  font-size: 52px;
  color: #63BFAA;
  opacity: 0;
}

.sect2 .volunteer .right {
  flex: 0 0 45%;
  line-height: 2em;
}

.sect2 .gallery {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  border-radius: 30px;
  overflow: hidden;
}

.sect2 .gallery .left {
  flex: 0 0 60%;  
}

.sect2 .gallery .left .imgContainer2-1 {
  width: 100%;
  background: url(@/assets/joinBenefit/pic2_02.jpg) center;
  background-size: cover;
}

.sect2 .gallery .right {
  flex: 0 0 39%;
}

.sect2 .gallery .right .imgContainer2-2 {
  width: 100%;
  background: url(@/assets/joinBenefit/pic2_03.jpg) center;
  background-size: cover;
}

.sect3 {
}

.sect3 .sectTit {
  width: 400px;
  margin: auto;
  padding: 10px 20px;
  box-sizing: border-box;
  border-radius: 50px;
  letter-spacing: 2px;
  text-align: center;
  font-size: 36px;
  color: #fff;
  background: #E99776;;
}

.sect3 p {
  line-height: 2em;
}

.sect3 .benefit {
  margin: 40px 0 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.sect3 .left {
  flex: 0 0 74.7%;
  display: flex;
  justify-content: space-between;  
  flex-wrap: wrap;
}

.sect3 .right {
flex: 0 0 24.3%;
background: #fff;
}

.sect3 .left .item {
  flex: 0 0 32.5%;  
  background: #fff;
}

.sect3 .item .icon img {
  width: 100%;
}

.sect3 .item .icon .tit {
  padding: 0 0 20px;
  box-sizing: border-box;
  text-align: center;
  font-size: 24px;
  color: #fff;
}

.sect3 .item .bList {
  padding: 15px;
  box-sizing: border-box;
  background: #fff;
}

.sect3 .item .bList div {
  margin: 10px 0;
  padding: 0 0 0 10px;
  box-sizing: border-box;
  border-left: solid 5px #808080;
  font-weight: 700;
}

.sect3 .item .bList div.note {
  border-left: solid 5px transparent;
  font-size: 14px;
  color: #808080;
  transform: translateY(-5px);
}

.sect3 .left .item:nth-child(1) .icon,
.sect3 .left .item:nth-child(3) .icon,
.sect3 .left .item:nth-child(4) .icon,
.sect3 .left .item:nth-child(6) .icon {
  background: #63bfaa;
}

.sect3 .left .item:nth-child(2) .icon,
.sect3 .left .item:nth-child(5) .icon {
  background: #82cbba;
}

.sect3 .right .item .icon {
  background: #82cbba;
}

@media screen and (min-width: 1367px) and (max-width: 1600px) {
  .kv .caption h1 {
    font-size: 48px;
  }
}

@media screen and (min-width: 1201px) and (max-width: 1366px) {
  .kv .caption h1 {
    font-size: 44px;
  }
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .kv .caption {
    width: 100%;
    padding: 10px 10px;
  }

  .kv .caption h1 {
    font-size: 40px;
  }

  .sect2 .volunteer {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .sect2 .volunteer .left {
    flex: 0 0 500px;
    margin: 20px auto 0;
  }

  .sect2 .volunteer .right {
    flex: 0 0 100%;
  }

    .sect3 .left {
    flex: 0 0 100%;
  }

  .sect3 .right {
    flex: 0 0 48%;
  }

  .sect3 .left .item {
    flex: 0 0 48%;
    margin: 0 0 35px;
    box-shadow: 0 0 5px #00000022;
  }
}

@media screen and (min-width: 1px) and (max-width: 767px) {
  .kv .caption {
    width: 100%;
    padding: 10px 10px;
  }

  .kv .caption h1 {
    font-size: 24px;
    text-shadow: 3px 3px 3px #00000066;
  }

  .sect1 .gallery .imgContainer .tit .icon {
    flex: 0 0 60px;
  }

  .sect1 .gallery .imgContainer1-1 {
    width: 100%;
    margin: 0 0 5px;
  }

  .sect1 .gallery .imgContainer1-2 {
    width: 100%;
    margin: 0 0 5px;
  }

  .sect1 .gallery .imgContainer1-3 {
    width: 100%;
    margin: 0 0 5px;
  }

  .sect1 .gallery .imgContainer1-4 {
    width: 100%;
  }

  .sect2 .sectTit {
    width: 150px;
    top: -25px;
    font-size: 20px;
  }

  .sect2 .volunteer .left {
    flex: 0 0 100%;
  }

  .sect2 .volunteer .right {
    flex: 0 0 100%;
  }

  .sect2 .volunteer .left .info {
    padding: 10px 20px 3px;
  }

  .sect2 .volunteer .left .info .block1 {
    width: 100%;
    border-right: none;
  }

  .sect2 .volunteer .left .info .block1 .year {
    font-weight: bold;
    font-size: 24px;
  }

  .sect2 .volunteer .left .info .block2 {
    width: 100%;
  }

  .sect2 .volunteer .left .info .block2 .num1,
  .sect2 .volunteer .left .info .block2 .num2 {
    font-size: 40px;
  }

  .sect2 .gallery .left {
    flex: 0 0 100%;
  }

  .sect2 .gallery .right {
    flex: 0 0 100%;
  }

  .sect2 .gallery .right .imgContainer2-2 {
    margin: 5px 0;
  }

  .sect3 .sectTit {
    width: 220px;
    font-size: 20px;
  }

  .sect3 .left {
    flex: 0 0 100%;
  }

  .sect3 .right {
    flex: 0 0 100%;
  }

  .sect3 .left .item {
    flex: 0 0 100%;
  }
}
</style>
